// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MemberRecord-module__font-s-10___IwqKv {
  font-size: 10px !important;
}

.MemberRecord-module__font-s-12___zs9j6 {
  font-size: 12px !important;
}

.MemberRecord-module__font-s-13___yfrzG {
  font-size: 13px !important;
}

.MemberRecord-module__font-s-14___GyuhG {
  font-size: 14px !important;
}

.MemberRecord-module__font-s-15___Z6bKc {
  font-size: 15px !important;
}

.MemberRecord-module__font-s-16___xwOkT {
  font-size: 16px !important;
}

.MemberRecord-module__font-s-18___TmJ3p {
  font-size: 18px !important;
}

.MemberRecord-module__font-s-20___ykdy_ {
  font-size: 20px !important;
}

.MemberRecord-module__font-s-22___axURb {
  font-size: 22px !important;
}

.MemberRecord-module__font-s-28___RG62U {
  font-size: 28px !important;
}

.MemberRecord-module__font-w-400___DoAj7 {
  font-weight: 400 !important;
}

.MemberRecord-module__font-w-500___lR4nh {
  font-weight: 500 !important;
}

.MemberRecord-module__font-w-600___Z1btE {
  font-weight: 600 !important;
}

.MemberRecord-module__font-w-700___ltZIY {
  font-weight: 700 !important;
}

.MemberRecord-module__p-5___JV9nE {
  padding: 5px !important;
}

.MemberRecord-module__p-12___Bj8J_ {
  padding: 12px !important;
}

.MemberRecord-module__p-16___e4J3m {
  padding: 16px !important;
}

.MemberRecord-module__p-30___YJlqb {
  padding: 30px !important;
}

.MemberRecord-module__p-b-0___ttjoh {
  padding-bottom: 0 !important;
}

.MemberRecord-module__p-b-5___vHvnu {
  padding-bottom: 5px !important;
}

.MemberRecord-module__p-b-10___m0YLw {
  padding-bottom: 10px !important;
}

.MemberRecord-module__p-b-12____7HKj {
  padding-bottom: 12px !important;
}

.MemberRecord-module__p-b-16___zsBTh {
  padding-bottom: 16px !important;
}

.MemberRecord-module__p-b-18___Qw6ML {
  padding-bottom: 18px !important;
}

.MemberRecord-module__p-b-20___AEOLV {
  padding-bottom: 20px !important;
}

.MemberRecord-module__p-b-25___DZse_ {
  padding-bottom: 25px !important;
}

.MemberRecord-module__p-b-30___0ZUfI {
  padding-bottom: 30px !important;
}

.MemberRecord-module__p-b-50___e41Fz {
  padding-bottom: 50px !important;
}

.MemberRecord-module__p-t-0___qxQG_ {
  padding-top: 0 !important;
}

.MemberRecord-module__p-t-12___etBjt {
  padding-top: 12px !important;
}

.MemberRecord-module__p-t-16___gF9Mz {
  padding-top: 16px !important;
}

.MemberRecord-module__p-t-18___BUrev {
  padding-top: 18px !important;
}

.MemberRecord-module__p-t-20___aMfbB {
  padding-top: 20px !important;
}

.MemberRecord-module__p-t-30___kBEnU {
  padding-top: 30px !important;
}

.MemberRecord-module__p-t-40___Dg1Ei {
  padding-top: 40px !important;
}

.MemberRecord-module__p-t-50___dQXxF {
  padding-top: 50px !important;
}

.MemberRecord-module__p-l-20___mswIQ {
  padding-left: 20px !important;
}

.MemberRecord-module__p-l-30___GurEm {
  padding-left: 30px !important;
}

.MemberRecord-module__p-l-40___gvjDh {
  padding-left: 40px !important;
}

.MemberRecord-module__p-r-16___NqFj_ {
  padding-right: 16px !important;
}

.MemberRecord-module__p-r-20___rmPp8 {
  padding-right: 20px !important;
}

.MemberRecord-module__p-r-30___OcMhu {
  padding-right: 30px !important;
}

.MemberRecord-module__p-r-50___hq7cr {
  padding-right: 50px !important;
}

.MemberRecord-module__p-r-60___evv3B {
  padding-right: 60px !important;
}

.MemberRecord-module__m-b-1___p9zLj {
  margin-bottom: 1px !important;
}

.MemberRecord-module__m-b-2___g35np {
  margin-bottom: 2px !important;
}

.MemberRecord-module__m-b-6___RrFdS {
  margin-bottom: 6px !important;
}

.MemberRecord-module__m-b-8___Ggfcz {
  margin-bottom: 8px !important;
}

.MemberRecord-module__m-b-10___la7iB {
  margin-bottom: 10px !important;
}

.MemberRecord-module__m-b-14___oKt_8 {
  margin-bottom: 14px !important;
}

.MemberRecord-module__m-b-16___qvico {
  margin-bottom: 16px !important;
}

.MemberRecord-module__m-b-20___CQYDD {
  margin-bottom: 20px !important;
}

.MemberRecord-module__m-b-22___xJuiQ {
  margin-bottom: 22px !important;
}

.MemberRecord-module__m-b-24___rU17I {
  margin-bottom: 24px !important;
}

.MemberRecord-module__m-b-30___bGS4v {
  margin-bottom: 30px !important;
}

.MemberRecord-module__m-b-32___HOEUP {
  margin-bottom: 32px !important;
}

.MemberRecord-module__m-b-40___CbxAz {
  margin-bottom: 40px !important;
}

.MemberRecord-module__m-t-2___gYBGc {
  margin-top: 2px !important;
}

.MemberRecord-module__m-t-3___qhqBp {
  margin-top: 3px !important;
}

.MemberRecord-module__m-t-4___ixtcV {
  margin-top: 4px !important;
}

.MemberRecord-module__m-t-5___JTO04 {
  margin-top: 5px !important;
}

.MemberRecord-module__m-t-8___g9v1V {
  margin-top: 8px !important;
}

.MemberRecord-module__m-t-10___icFsa {
  margin-top: 10px !important;
}

.MemberRecord-module__m-t-15___d22vO {
  margin-top: 15px !important;
}

.MemberRecord-module__m-t-16___PuGkE {
  margin-top: 16px !important;
}

.MemberRecord-module__m-t-20___gPr_5 {
  margin-top: 20px !important;
}

.MemberRecord-module__m-t-22___R0xu2 {
  margin-top: 22px !important;
}

.MemberRecord-module__m-t-30___Eiitd {
  margin-top: 30px !important;
}

.MemberRecord-module__m-t-32___ryX2l {
  margin-top: 32px !important;
}

.MemberRecord-module__m-l-auto___c85fR {
  margin-left: auto !important;
}

.MemberRecord-module__m-l-4___doPAy {
  margin-left: 4px !important;
}

.MemberRecord-module__m-l-5___MV1xO {
  margin-left: 5px !important;
}

.MemberRecord-module__m-l-6___R3azx {
  margin-left: 6px !important;
}

.MemberRecord-module__m-l-8___xKx6E {
  margin-left: 8px !important;
}

.MemberRecord-module__m-l-10___B3sLZ {
  margin-left: 10px !important;
}

.MemberRecord-module__m-l-16___tI8Ft {
  margin-left: 16px !important;
}

.MemberRecord-module__m-l-20___KWJJO {
  margin-left: 20px !important;
}

.MemberRecord-module__m-l-24___rcWVu {
  margin-left: 24px !important;
}

.MemberRecord-module__m-l-30___vGJai {
  margin-left: 30px !important;
}

.MemberRecord-module__m-l-35___v1SD3 {
  margin-left: 35px !important;
}

.MemberRecord-module__m-l-40___QTWhw {
  margin-left: 40px !important;
}

.MemberRecord-module__m-r-8___KiBZK {
  margin-right: 8px !important;
}

.MemberRecord-module__m-r-10___uxJVm {
  margin-right: 10px !important;
}

.MemberRecord-module__m-r-16___uswxv {
  margin-right: 16px !important;
}

.MemberRecord-module__m-r-20___M0DvQ {
  margin-right: 20px !important;
}

.MemberRecord-module__m-r-24___dGdpy {
  margin-right: 24px !important;
}

.MemberRecord-module__m-r-30___MjLO3 {
  margin-right: 30px !important;
}

.MemberRecord-module__m-r-40___HodzU {
  margin-right: 40px !important;
}

.MemberRecord-module__border-r-3___JMyQ2 {
  border-radius: 3px !important;
}

.MemberRecord-module__border-r-4___STTXa {
  border-radius: 4px !important;
}

.MemberRecord-module__border-r-6___QcaCO {
  border-radius: 6px !important;
}

.MemberRecord-module__border-r-10___cISOa {
  border-radius: 10px !important;
}

.MemberRecord-module__border-r-12___REv0V {
  border-radius: 12px !important;
}

.MemberRecord-module__border-r-16___qkmqP {
  border-radius: 16px !important;
}

.MemberRecord-module__border-r-50___IVUEh {
  border-radius: 50% !important;
}

.MemberRecord-module__primary-border___lDlUp {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.MemberRecord-module__primary-border-b___zlBwZ {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.MemberRecord-module__primary-border-t___mR8SY {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.MemberRecord-module__primary-border-l___Ajh0J {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.MemberRecord-module__primary-border-r___z3Rla {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.MemberRecord-module__secondary-border___Z4zXK {
  border: 1px solid #637768;
}

.MemberRecord-module__secondary-border-b___vYnhk {
  border-bottom: 1px solid #637768;
}

.MemberRecord-module__secondary-border-t___g1rQ6 {
  border-top: 1px solid #637768;
}

.MemberRecord-module__secondary-border-l___FEZdc {
  border-left: 1px solid #637768;
}

.MemberRecord-module__secondary-border-r___tPlvU {
  border-right: 1px solid #637768;
}

.MemberRecord-module__gap-0___AwfVP {
  gap: 0 !important;
}

.MemberRecord-module__gap-2___qZkGq {
  gap: 2px !important;
}

.MemberRecord-module__gap-4___I98vK {
  gap: 4px !important;
}

.MemberRecord-module__gap-5___qj1ae {
  gap: 5px !important;
}

.MemberRecord-module__gap-6___pxPiz {
  gap: 6px !important;
}

.MemberRecord-module__gap-8___KxMSc {
  gap: 8px !important;
}

.MemberRecord-module__gap-10___fpYMg {
  gap: 10px !important;
}

.MemberRecord-module__gap-12___BKg_n {
  gap: 12px !important;
}

.MemberRecord-module__gap-14___IGGCO {
  gap: 14px !important;
}

.MemberRecord-module__gap-16___Y5ISY {
  gap: 16px !important;
}

.MemberRecord-module__gap-18___PrDar {
  gap: 18px !important;
}

.MemberRecord-module__gap-20___SLdAc {
  gap: 20px !important;
}

.MemberRecord-module__gap-24___KiSF0 {
  gap: 24px !important;
}

.MemberRecord-module__gap-26___H_Pya {
  gap: 26px !important;
}

.MemberRecord-module__gap-30___bhcGg {
  gap: 30px !important;
}

.MemberRecord-module__gap-32___XU0BQ {
  gap: 32px !important;
}

.MemberRecord-module__gap-40___oE04Y {
  gap: 40px !important;
}

.MemberRecord-module__gap-50___YwMHq {
  gap: 50px !important;
}

.MemberRecord-module__flex-1___GvhpR {
  flex: 1;
}

.MemberRecord-module__flex-none___IKqVw {
  flex: none !important;
}

.MemberRecord-module__flex-column___ybfeP {
  display: flex;
  flex-direction: column !important;
}

.MemberRecord-module__flex-row____RIXi {
  display: flex;
  flex-direction: row !important;
}

.MemberRecord-module__vertically-centered___ai8I3 {
  display: flex;
  align-items: center !important;
}

.MemberRecord-module__horizontally-centered___RH2jB {
  display: flex;
  justify-content: center !important;
}

.MemberRecord-module__horizontally-end___fA1Ke {
  display: flex;
  justify-content: end !important;
}

.MemberRecord-module__vertically-start___pFlIh {
  display: flex;
  align-items: start !important;
}

.MemberRecord-module__space-between___04goC {
  display: flex;
  justify-content: space-between !important;
}

.MemberRecord-module__flex-wrap___qmjAN {
  flex-wrap: wrap !important;
}

.MemberRecord-module__height-100___qkYHH {
  height: 100%;
}

.MemberRecord-module__width-50___xw_J9 {
  width: 50% !important;
}

.MemberRecord-module__width-100___mIFmG {
  width: 100%;
}

.MemberRecord-module__cursor-pointer___qNoo4 {
  cursor: pointer;
}

.MemberRecord-module__cursor-not-allowed___UAe7H {
  cursor: not-allowed !important;
}

.MemberRecord-module__absolute-centered___Q6EiG {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.MemberRecord-module__absolute___UIpKu {
  position: absolute;
}

.MemberRecord-module__relative___VI_CY {
  position: relative;
}

.MemberRecord-module__fixed___ptKh7 {
  position: fixed;
}

.MemberRecord-module__visible___yCtv1 {
  opacity: 1;
}

.MemberRecord-module__invisible___Rb6zo {
  opacity: 0;
}

.MemberRecord-module__col-90___ecrA6 {
  width: 90% !important;
}

.MemberRecord-module__col-auto___VoNRw {
  width: auto !important;
}

.MemberRecord-module__medical-tabs___Y8Lqo {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.MemberRecord-module__medical-table-new___YEKEv {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MemberRecord-module__medical-table-new___YEKEv:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MemberRecord-module__medical-table-new___YEKEv::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MemberRecord-module__medical-table-new___YEKEv::-webkit-scrollbar-track {
  display: none;
}
.MemberRecord-module__medical-table-new___YEKEv.MemberRecord-module__no-pagination___Not4l {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MemberRecord-module__medical-table-new___YEKEv.MemberRecord-module__no-pagination___Not4l:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MemberRecord-module__medical-table-new___YEKEv.MemberRecord-module__no-pagination___Not4l::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MemberRecord-module__medical-table-new___YEKEv.MemberRecord-module__no-pagination___Not4l::-webkit-scrollbar-track {
  display: none;
}

.MemberRecord-module__medical-table-empty___ZLsOr {
  padding: 14px 40px !important;
}

.MemberRecord-module__icon-btn___CBuHo {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.MemberRecord-module__search-icon___HQNgv {
  width: 24px;
  height: 24px;
  align-self: center;
}

.MemberRecord-module__disable-select___b5i1I {
  user-select: none;
}

.MemberRecord-module__break-word___hGejV {
  word-break: break-word;
}

.MemberRecord-module__popup-clear-btn___Sby4L {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.MemberRecord-module__scroll-m-b-20___DUSyu {
  scroll-margin-bottom: 20px;
}

.MemberRecord-module__page___Xw_QX {
  height: 100%;
  overflow-y: auto;
  background: #fafafa;
}

.MemberRecord-module__pageInner___mAa4D {
  max-width: 1400px;
  margin: 0 auto;
  padding: 16px 20px 40px;
}

.MemberRecord-module__flex___tZ0XY {
  flex: 1;
}

.MemberRecord-module__crumbs___s8V_d {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
  font-size: 13px;
}

.MemberRecord-module__crumbButton___LyJZs {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: 0;
  background: transparent;
  font: inherit;
  color: #71717a;
  cursor: pointer;
}
.MemberRecord-module__crumbButton___LyJZs:hover {
  color: #18181b;
}
.MemberRecord-module__crumbButton___LyJZs:focus-visible {
  outline: none;
}
.MemberRecord-module__crumbButton___LyJZs:focus-visible:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 1px;
}

.MemberRecord-module__backButton___DuH3H {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  border: 1px solid #e4e4e7;
  border-radius: 5px;
  background: #ffffff;
  color: #52525b;
  cursor: pointer;
}
.MemberRecord-module__backButton___DuH3H:hover {
  border-color: #a1a1aa;
  color: #18181b;
}
.MemberRecord-module__backButton___DuH3H:focus-visible {
  outline: none;
}
.MemberRecord-module__backButton___DuH3H:focus-visible:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 1px;
}

.MemberRecord-module__crumbSep___hl27P {
  color: #d4d4d8;
}

.MemberRecord-module__crumbStrong___rSBKC {
  font-weight: 500;
  color: #18181b;
}

.MemberRecord-module__athena___oMRDa {
  flex-shrink: 0;
}

.MemberRecord-module__contentBar___fc2Yd {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.MemberRecord-module__summary___QmuS7 {
  font-size: 13px;
  color: #71717a;
}

.MemberRecord-module__crumbCurrent___U6SXY,
.MemberRecord-module__switchTrigger___eo37R {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: 500;
  color: #18181b;
}

.MemberRecord-module__switchTrigger___eo37R {
  cursor: pointer;
}

.MemberRecord-module__switchMenu___B3zKH #menu-paper {
  overflow-y: auto;
  max-height: 420px !important;
}
.MemberRecord-module__switchMenu___B3zKH #menu-paper > div {
  border-bottom: 0 !important;
}
.MemberRecord-module__switchMenu___B3zKH #menu-paper > div:has(.MemberRecord-module__switchHeading___P3mOc) {
  pointer-events: none;
  background: transparent !important;
}

.MemberRecord-module__switchHeading___P3mOc {
  padding: 8px 10px 4px;
}

.MemberRecord-module__switchHeadingHint___baBgn {
  margin-left: 6px;
  font-weight: 400;
  letter-spacing: 0;
  text-transform: none;
}

.MemberRecord-module__switchOption___Xk1Zr {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 10px;
  text-align: left;
}

.MemberRecord-module__switchCheck___DL4Uy {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  width: 14px;
  height: 20px;
  color: #18181b;
}

.MemberRecord-module__switchBody___GddhE {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.MemberRecord-module__switchOptionCurrent___qwJuF {
  background: #fafafa;
}

.MemberRecord-module__switchTop___LEHPk,
.MemberRecord-module__switchBottom___XDHtF {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.MemberRecord-module__switchBottom___XDHtF {
  align-items: center;
}

.MemberRecord-module__switchName___pQVJD {
  font-size: 14px;
  font-weight: 500;
  color: #18181b;
}

.MemberRecord-module__switchMrn___OTN8z {
  font-family: "IBM Plex Mono", monospace;
  font-size: 12px;
  color: #a1a1aa;
}

.MemberRecord-module__switchDue___zKK8M {
  font-family: "IBM Plex Mono", monospace;
  font-size: 12px;
  color: #71717a;
}

.MemberRecord-module__switchDueUrgent___lwnV6 {
  font-weight: 600;
  color: #b91c1c;
}

.MemberRecord-module__switchDueCritical___s221B {
  font-weight: 600;
  color: #18181b;
}

.MemberRecord-module__switchTask___GOect {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  color: #71717a;
}

.MemberRecord-module__switchCount___mC5s0 {
  font-size: 12px;
  color: #a1a1aa;
}

.MemberRecord-module__memberHeader___tXRW_ {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  flex-wrap: wrap;
}

.MemberRecord-module__avatar___FsucQ {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: #18181b;
  font-size: 16px;
  font-weight: 600;
  color: #fafafa;
}

.MemberRecord-module__memberIdentity___nokC9 {
  flex: 1;
  min-width: 260px;
}

.MemberRecord-module__memberNameLine___icHpX {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.MemberRecord-module__memberName___eXlw_ {
  font-size: 20px;
  font-weight: 600;
  color: #18181b;
}

.MemberRecord-module__memberAge___n9c1y {
  font-size: 13px;
  color: #71717a;
}

.MemberRecord-module__memberMrn___sEC8k {
  font-family: "IBM Plex Mono", monospace;
  font-size: 13px;
  color: #a1a1aa;
}

.MemberRecord-module__memberContext___XyJvF {
  margin-top: 6px;
  font-size: 13px;
  color: #71717a;
}

.MemberRecord-module__tabsRow___RzZQF {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 18px 0 12px;
}

.MemberRecord-module__pills___ZCF7O {
  display: flex;
  gap: 1px;
  padding: 2px;
  border-radius: 5px;
  background: #f4f4f5;
}

.MemberRecord-module__pill___nXVSG {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 14px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  color: #71717a;
  cursor: pointer;
}
.MemberRecord-module__pill___nXVSG:focus-visible {
  outline: none;
}
.MemberRecord-module__pill___nXVSG:focus-visible:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 1px;
}

.MemberRecord-module__pillActive___hVgJd {
  background: #ffffff;
  color: #18181b;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

.MemberRecord-module__pillCount___JyY9H {
  font-family: "IBM Plex Mono", monospace;
  font-size: 12px;
  color: #a1a1aa;
}

.MemberRecord-module__pillActive___hVgJd .MemberRecord-module__pillCount___JyY9H {
  color: #b91c1c;
}

.MemberRecord-module__toggle___lPJOR {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 4px 10px;
  border: 1px solid #e4e4e7;
  border-radius: 5px;
  background: #ffffff;
  font: inherit;
  font-size: 13px;
  font-weight: 500;
  color: #71717a;
  cursor: pointer;
}
.MemberRecord-module__toggle___lPJOR:focus-visible {
  outline: none;
}
.MemberRecord-module__toggle___lPJOR:focus-visible:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 1px;
}

.MemberRecord-module__toggleOn___tLewR {
  border-color: #bbf7d0;
  background: #f0fdf4;
  color: #15803d;
}

.MemberRecord-module__toggleTrack___iDAJC {
  position: relative;
  flex-shrink: 0;
  width: 26px;
  height: 14px;
  border-radius: 999px;
  background: #d4d4d8;
  transition: background-color 0.15s;
}

.MemberRecord-module__toggleOn___tLewR .MemberRecord-module__toggleTrack___iDAJC {
  background: #22c55e;
}

.MemberRecord-module__toggleThumb___avDb3 {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ffffff;
  transition: left 0.15s;
}

.MemberRecord-module__toggleOn___tLewR .MemberRecord-module__toggleThumb___avDb3 {
  left: 14px;
}

.MemberRecord-module__errorNote___I_eoo,
.MemberRecord-module__emptyNote___xa3zv {
  padding: 10px 16px;
  font-size: 13px;
  color: #a1a1aa;
}

.MemberRecord-module__timelineCard___rMBlT,
.MemberRecord-module__listCard___EdVF9 {
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #ffffff;
  overflow: hidden;
}

.MemberRecord-module__timelineCard___rMBlT {
  padding: 10px 18px 4px 6px;
  overflow: visible;
}

.MemberRecord-module__tasksTab___d1RMS {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.MemberRecord-module__anchoredRow___Aqm9W {
  display: flex;
}

.MemberRecord-module__dateGutter___nPm_O {
  flex-shrink: 0;
  width: 56px;
  padding-top: 14px;
  text-align: center;
}

.MemberRecord-module__dateMonth___k9NMY {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.06em;
  color: #a1a1aa;
}

.MemberRecord-module__dateDay___UmL83 {
  font-family: "IBM Plex Mono", monospace;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.1;
  color: #52525b;
}

.MemberRecord-module__dateAccent___EsV8x {
  color: #18181b;
}

.MemberRecord-module__dateYear___YAr70 {
  font-family: "IBM Plex Mono", monospace;
  font-size: 10px;
  color: #a1a1aa;
}

.MemberRecord-module__spine___S2Nry {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  width: 28px;
}

.MemberRecord-module__spineLead___pDKUH {
  width: 1.5px;
  height: 18px;
  background: #e4e4e7;
}

.MemberRecord-module__spineTail___ldE0W,
.MemberRecord-module__spineFull___izuC6 {
  flex: 1;
  width: 1.5px;
  background: #e4e4e7;
}

.MemberRecord-module__spineFull___izuC6 {
  min-height: 100%;
}

.MemberRecord-module__node___zhxdO {
  flex-shrink: 0;
  border-radius: 50%;
}

.MemberRecord-module__nodeVisit___m2leA {
  width: 13px;
  height: 13px;
  border: 3px solid #ffffff;
  background: #18181b;
  box-shadow: 0 0 0 1.5px #18181b;
}

.MemberRecord-module__nodeUpcoming___eivyN {
  width: 13px;
  height: 13px;
  border: 3px solid #ffffff;
  background: #ffffff;
  box-shadow: 0 0 0 1.5px #a1a1aa;
}

.MemberRecord-module__nodeGreen___N_fSh {
  box-shadow: 0 0 0 1.5px #22c55e;
}

.MemberRecord-module__nodeYellow___crO9U {
  box-shadow: 0 0 0 1.5px #eab308;
}

.MemberRecord-module__nodeRed___UrXG_ {
  box-shadow: 0 0 0 1.5px #ef4444;
}

.MemberRecord-module__nodeFuture___fxUlH {
  width: 9px;
  height: 9px;
  border: 1.5px dashed #a1a1aa;
  background: #ffffff;
}

.MemberRecord-module__nodeDot___Ho4l0 {
  width: 7px;
  height: 7px;
  background: #d4d4d8;
}

.MemberRecord-module__rowBody___gvfA2 {
  flex: 1;
  min-width: 0;
  padding: 6px 0 18px 12px;
}

.MemberRecord-module__episodeCard___JNheI,
.MemberRecord-module__cluster___tbaUF,
.MemberRecord-module__upcoming___u49M9,
.MemberRecord-module__future___N9Oa1 {
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #ffffff;
  overflow: hidden;
}

.MemberRecord-module__episodeHead___N7mcm,
.MemberRecord-module__upcomingHead___BT7_M {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 16px 10px;
}

.MemberRecord-module__episodeTitle___Ljv0H {
  font-size: 15px;
  font-weight: 600;
  color: #18181b;
}

.MemberRecord-module__episodeMeta___kUVfJ {
  font-size: 12px;
  color: #a1a1aa;
}

.MemberRecord-module__groupBand___SAXJz {
  padding-left: 16px;
  padding-right: 16px;
}

.MemberRecord-module__collapsedCluster___iWC08 {
  padding: 6px 2px;
  font-size: 13px;
  color: #a1a1aa;
}

.MemberRecord-module__cluster___tbaUF {
  background: #fafafa;
}

.MemberRecord-module__clusterOpen___EkLvG {
  background: #ffffff;
}

.MemberRecord-module__bandRight___poJnN {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.MemberRecord-module__bandNow___gXvF3 {
  font-size: 13px;
  color: #a1a1aa;
}

.MemberRecord-module__allCompleteText___rOmLY {
  font-size: 13px;
  font-weight: 500;
  color: #15803d;
}

.MemberRecord-module__upcoming___u49M9 {
  border-left-width: 4px;
}

.MemberRecord-module__upcomingGreen___kdabb {
  border-color: #bbf7d0;
  border-left-color: #22c55e;
}

.MemberRecord-module__upcomingYellow___KL2eE {
  border-color: #fde68a;
  border-left-color: #eab308;
}

.MemberRecord-module__upcomingRed____x_MU {
  border-color: #fecaca;
  border-left-color: #ef4444;
}

.MemberRecord-module__upcomingNeutral___PMQcF {
  border-left-color: #a1a1aa;
}

.MemberRecord-module__upcoming___u49M9 > .MemberRecord-module__episodeMeta___kUVfJ {
  padding: 0 16px 10px;
}

.MemberRecord-module__upcomingWhen___oby23 {
  font-family: "IBM Plex Mono", monospace;
  font-size: 13px;
  font-weight: 600;
  color: #18181b;
}

.MemberRecord-module__upcomingReadiness___OqIt1 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 16px 12px;
  border-top: 1px solid #f4f4f5;
}

.MemberRecord-module__lineButton___WQvRF {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  color: #18181b;
  text-decoration: underline;
  text-decoration-color: #d4d4d8;
  text-underline-offset: 3px;
  cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s;
}
.MemberRecord-module__lineButton___WQvRF:hover:not(:disabled) {
  border-color: #d4d4d8;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  text-decoration: none;
}
.MemberRecord-module__lineButton___WQvRF {
  outline: none;
}
.MemberRecord-module__lineButton___WQvRF:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 1px;
}
.MemberRecord-module__lineButton___WQvRF:disabled, .MemberRecord-module__lineButton___WQvRF[aria-disabled=true] {
  color: #a1a1aa;
  cursor: default;
}
.MemberRecord-module__lineButton___WQvRF {
  margin: 0 8px 10px;
}

.MemberRecord-module__future___N9Oa1 {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-style: dashed;
  border-color: #d4d4d8;
}

.MemberRecord-module__futureTitle___hth6D {
  font-size: 14px;
  font-weight: 500;
  color: #52525b;
}

.MemberRecord-module__projected___H3wzs {
  border-style: dashed;
}

.MemberRecord-module__nowRow___tqi06 {
  display: flex;
  align-items: center;
}

.MemberRecord-module__nowLabel____uSQN {
  flex-shrink: 0;
  width: 56px;
  text-align: center;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #0369a1;
}

.MemberRecord-module__nowDot___LNCnW {
  flex-shrink: 0;
  width: 9px;
  height: 9px;
  margin: 0 9.5px;
  border-radius: 50%;
  background: #0ea5e9;
  box-shadow: 0 0 0 3px #f0f9ff;
}

.MemberRecord-module__nowLine___pavZS {
  flex: 1;
  height: 1.5px;
  margin-left: 12px;
  background: repeating-linear-gradient(90deg, #bae6fd 0 6px, transparent 6px 12px);
}

.MemberRecord-module__nowDate___yhatn {
  padding-left: 10px;
  font-family: "IBM Plex Mono", monospace;
  font-size: 12px;
  color: #a1a1aa;
}

.MemberRecord-module__switchTrigger___eo37R svg {
  width: 12px;
  height: 12px;
  color: #a1a1aa;
}

.MemberRecord-module__episodeHeadRuled___tU3ZA {
  border-bottom: 1px solid #f4f4f5;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/CareOrchestration/components/MemberRecord/MemberRecord.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_visit.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;AA8pBF;;AA3pBA;EACE,iBAAA;EACA,cAAA;EACA,uBAAA;AA8pBF;;AA3pBA;EACE,OAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;AA8pBF;;AA3pBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;AA8pBF;AA5pBE;EACE,cAAA;AA8pBJ;AA3pBE;EEFA,aAAA;AFgqBF;AE9pBE;EACE,0BAAA;EACA,mBALuB;AFqqB3B;;AA7pBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAgqBF;AA9pBE;EACE,qBAAA;EACA,cAAA;AAgqBJ;AA7pBE;EEzBA,aAAA;AFyrBF;AEvrBE;EACE,0BAAA;EACA,mBALuB;AF8rB3B;;AA/pBA;EACE,cAAA;AAkqBF;;AA/pBA;EACE,gBAAA;EACA,cAAA;AAkqBF;;AA/pBA;EACE,cAAA;AAkqBF;;AA/pBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAkqBF;;AA/pBA;EACE,eAAA;EACA,cAAA;AAkqBF;;AA/pBA;;EAEE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;AAkqBF;;AA/pBA;EACE,eAAA;AAkqBF;;AA/pBA;EACE,gBAAA;EACA,4BAAA;AAkqBF;AAhqBE;EACE,2BAAA;AAkqBJ;AA/pBE;EACE,oBAAA;EACA,kCAAA;AAiqBJ;;AA7pBA;EACE,qBAAA;AAgqBF;;AA7pBA;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AAgqBF;;AA7pBA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;AAgqBF;;AA7pBA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAgqBF;;AA7pBA;EACE,aAAA;EACA,OAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAgqBF;;AA7pBA;EACE,mBAAA;AAgqBF;;AA7pBA;;EAEE,aAAA;EACA,qBAAA;EACA,QAAA;AAgqBF;;AA7pBA;EACE,mBAAA;AAgqBF;;AA7pBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAgqBF;;AA7pBA;EACE,uCAAA;EACA,eAAA;EACA,cAAA;AAgqBF;;AA7pBA;EACE,uCAAA;EACA,eAAA;EACA,cAAA;AAgqBF;;AA7pBA;EACE,gBAAA;EACA,cAAA;AAgqBF;;AA7pBA;EACE,gBAAA;EACA,cAAA;AAgqBF;;AA7pBA;EACE,OAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AAgqBF;;AA7pBA;EACE,eAAA;EACA,cAAA;AAgqBF;;AA7pBA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;AAgqBF;;AA7pBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAgqBF;;AA7pBA;EACE,OAAA;EACA,gBAAA;AAgqBF;;AA7pBA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AAgqBF;;AA7pBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAgqBF;;AA7pBA;EACE,eAAA;EACA,cAAA;AAgqBF;;AA7pBA;EACE,uCAAA;EACA,eAAA;EACA,cAAA;AAgqBF;;AA7pBA;EACE,eAAA;EACA,eAAA;EACA,cAAA;AAgqBF;;AA7pBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAgqBF;;AA7pBA;EACE,aAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AAgqBF;;AA7pBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAgqBF;AA9pBE;EErQA,aAAA;AFs6BF;AEp6BE;EACE,0BAAA;EACA,mBALuB;AF26B3B;;AAhqBA;EACE,mBAAA;EACA,cAAA;EACA,yCAAA;AAmqBF;;AAhqBA;EACE,uCAAA;EACA,eAAA;EACA,cAAA;AAmqBF;;AAhqBA;EACE,cAAA;AAmqBF;;AAhqBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAmqBF;AAjqBE;EExSA,aAAA;AF48BF;AE18BE;EACE,0BAAA;EACA,mBALuB;AFi9B3B;;AAnqBA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AAsqBF;;AAnqBA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,kCAAA;AAsqBF;;AAnqBA;EACE,mBAAA;AAsqBF;;AAnqBA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AAsqBF;;AAnqBA;EACE,UAAA;AAsqBF;;AAnqBA;;EAEE,kBAAA;EACA,eAAA;EACA,cAAA;AAsqBF;;AAnqBA;;EAEE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAsqBF;;AAnqBA;EACE,0BAAA;EACA,iBAAA;AAsqBF;;AAnqBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAsqBF;;AAnqBA;EACE,aAAA;AAsqBF;;AAnqBA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AAsqBF;;AAnqBA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;AAsqBF;;AAnqBA;EACE,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAsqBF;;AAnqBA;EACE,cAAA;AAsqBF;;AAnqBA;EACE,uCAAA;EACA,eAAA;EACA,cAAA;AAsqBF;;AAnqBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;AAsqBF;;AAnqBA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;AAsqBF;;AAnqBA;;EAEE,OAAA;EACA,YAAA;EACA,mBAAA;AAsqBF;;AAnqBA;EACE,gBAAA;AAsqBF;;AAnqBA;EACE,cAAA;EACA,kBAAA;AAsqBF;;AAnqBA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,+BAAA;AAsqBF;;AAnqBA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,+BAAA;AAsqBF;;AAnqBA;EACE,+BAAA;AAsqBF;;AAnqBA;EACE,+BAAA;AAsqBF;;AAnqBA;EACE,+BAAA;AAsqBF;;AAnqBA;EACE,UAAA;EACA,WAAA;EACA,4BAAA;EACA,mBAAA;AAsqBF;;AAnqBA;EACE,UAAA;EACA,WAAA;EACA,mBAAA;AAsqBF;;AAnqBA;EACE,OAAA;EACA,YAAA;EACA,wBAAA;AAsqBF;;AAnqBA;;;;EAIE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAsqBF;;AAnqBA;;EAEE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,uBAAA;AAsqBF;;AAnqBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAsqBF;;AAnqBA;EACE,eAAA;EACA,cAAA;AAsqBF;;AAnqBA;EACE,kBAAA;EACA,mBAAA;AAsqBF;;AAnqBA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAsqBF;;AAnqBA;EACE,mBAAA;AAsqBF;;AAnqBA;EACE,mBAAA;AAsqBF;;AAnqBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;AAsqBF;;AAnqBA;EACE,eAAA;EACA,cAAA;AAsqBF;;AAnqBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAsqBF;;AAnqBA;EACE,sBAAA;AAsqBF;;AAnqBA;EACE,qBAAA;EACA,0BAAA;AAsqBF;;AAnqBA;EACE,qBAAA;EACA,0BAAA;AAsqBF;;AAnqBA;EACE,qBAAA;EACA,0BAAA;AAsqBF;;AAnqBA;EACE,0BAAA;AAsqBF;;AAnqBA;EACE,oBAAA;AAsqBF;;AAnqBA;EACE,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAsqBF;;AAnqBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,uBAAA;EACA,6BAAA;AAsqBF;;AAnqBA;EE/jBE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,eAAA;EACA,sDAAA;AFsuCF;AEpuCE;EACE,qBAAA;EACA,mBAAA;EACA,yCAAA;EACA,qBAAA;AFsuCJ;AA7rBA;EExkBE,aAAA;AFwwCF;AEtwCE;EACE,0BAAA;EACA,mBALuB;AF6wC3B;AExuCE;EAEE,cAAA;EACA,eAAA;AFyuCJ;AAxsBA;EAEE,kBAAA;AAysBF;;AAtsBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;AAysBF;;AAtsBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAysBF;;AAtsBA;EACE,oBAAA;AAysBF;;AAtsBA;EACE,aAAA;EACA,mBAAA;AAysBF;;AAtsBA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAysBF;;AAtsBA;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;AAysBF;;AAtsBA;EACE,OAAA;EACA,aAAA;EACA,iBAAA;EACA,iFAAA;AAysBF;;AAtsBA;EACE,kBAAA;EACA,uCAAA;EACA,eAAA;EACA,cAAA;AAysBF;;AAtsBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAysBF;;AAtsBA;EACE,gCAAA;AAysBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.page {\n  height: 100%;\n  overflow-y: auto;\n  background: #fafafa;\n}\n\n.pageInner {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 16px 20px 40px;\n}\n\n.flex {\n  flex: 1;\n}\n\n.crumbs {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 14px;\n  font-size: 13px;\n}\n\n.crumbButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  font: inherit;\n  color: #71717a;\n  cursor: pointer;\n\n  &:hover {\n    color: #18181b;\n  }\n\n  &:focus-visible {\n    @include focus-ring;\n  }\n}\n\n.backButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  padding: 0;\n  border: 1px solid #e4e4e7;\n  border-radius: 5px;\n  background: #ffffff;\n  color: #52525b;\n  cursor: pointer;\n\n  &:hover {\n    border-color: #a1a1aa;\n    color: #18181b;\n  }\n\n  &:focus-visible {\n    @include focus-ring;\n  }\n}\n\n.crumbSep {\n  color: #d4d4d8;\n}\n\n.crumbStrong {\n  font-weight: 500;\n  color: #18181b;\n}\n\n.athena {\n  flex-shrink: 0;\n}\n\n.contentBar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.summary {\n  font-size: 13px;\n  color: #71717a;\n}\n\n.crumbCurrent,\n.switchTrigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-weight: 500;\n  color: #18181b;\n}\n\n.switchTrigger {\n  cursor: pointer;\n}\n\n.switchMenu :global(#menu-paper) {\n  overflow-y: auto;\n  max-height: 420px !important;\n\n  > div {\n    border-bottom: 0 !important;\n  }\n\n  > div:has(.switchHeading) {\n    pointer-events: none;\n    background: transparent !important;\n  }\n}\n\n.switchHeading {\n  padding: 8px 10px 4px;\n}\n\n.switchHeadingHint {\n  margin-left: 6px;\n  font-weight: 400;\n  letter-spacing: 0;\n  text-transform: none;\n}\n\n.switchOption {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 8px 10px;\n  text-align: left;\n}\n\n.switchCheck {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  width: 14px;\n  height: 20px;\n  color: #18181b;\n}\n\n.switchBody {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.switchOptionCurrent {\n  background: #fafafa;\n}\n\n.switchTop,\n.switchBottom {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n\n.switchBottom {\n  align-items: center;\n}\n\n.switchName {\n  font-size: 14px;\n  font-weight: 500;\n  color: #18181b;\n}\n\n.switchMrn {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 12px;\n  color: #a1a1aa;\n}\n\n.switchDue {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 12px;\n  color: #71717a;\n}\n\n.switchDueUrgent {\n  font-weight: 600;\n  color: #b91c1c;\n}\n\n.switchDueCritical {\n  font-weight: 600;\n  color: #18181b;\n}\n\n.switchTask {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 12px;\n  color: #71717a;\n}\n\n.switchCount {\n  font-size: 12px;\n  color: #a1a1aa;\n}\n\n.memberHeader {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  flex-wrap: wrap;\n}\n\n.avatar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 46px;\n  height: 46px;\n  border-radius: 50%;\n  background: #18181b;\n  font-size: 16px;\n  font-weight: 600;\n  color: #fafafa;\n}\n\n.memberIdentity {\n  flex: 1;\n  min-width: 260px;\n}\n\n.memberNameLine {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.memberName {\n  font-size: 20px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.memberAge {\n  font-size: 13px;\n  color: #71717a;\n}\n\n.memberMrn {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 13px;\n  color: #a1a1aa;\n}\n\n.memberContext {\n  margin-top: 6px;\n  font-size: 13px;\n  color: #71717a;\n}\n\n.tabsRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 18px 0 12px;\n}\n\n.pills {\n  display: flex;\n  gap: 1px;\n  padding: 2px;\n  border-radius: 5px;\n  background: #f4f4f5;\n}\n\n.pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 14px;\n  border: 0;\n  border-radius: 4px;\n  background: transparent;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  color: #71717a;\n  cursor: pointer;\n\n  &:focus-visible {\n    @include focus-ring;\n  }\n}\n\n.pillActive {\n  background: #ffffff;\n  color: #18181b;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);\n}\n\n.pillCount {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 12px;\n  color: #a1a1aa;\n}\n\n.pillActive .pillCount {\n  color: #b91c1c;\n}\n\n.toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 4px 10px;\n  border: 1px solid #e4e4e7;\n  border-radius: 5px;\n  background: #ffffff;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  color: #71717a;\n  cursor: pointer;\n\n  &:focus-visible {\n    @include focus-ring;\n  }\n}\n\n.toggleOn {\n  border-color: #bbf7d0;\n  background: #f0fdf4;\n  color: #15803d;\n}\n\n.toggleTrack {\n  position: relative;\n  flex-shrink: 0;\n  width: 26px;\n  height: 14px;\n  border-radius: 999px;\n  background: #d4d4d8;\n  transition: background-color 0.15s;\n}\n\n.toggleOn .toggleTrack {\n  background: #22c55e;\n}\n\n.toggleThumb {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #ffffff;\n  transition: left 0.15s;\n}\n\n.toggleOn .toggleThumb {\n  left: 14px;\n}\n\n.errorNote,\n.emptyNote {\n  padding: 10px 16px;\n  font-size: 13px;\n  color: #a1a1aa;\n}\n\n.timelineCard,\n.listCard {\n  border: 1px solid $hairline;\n  border-radius: 8px;\n  background: #ffffff;\n  overflow: hidden;\n}\n\n.timelineCard {\n  padding: 10px 18px 4px 6px;\n  overflow: visible;\n}\n\n.tasksTab {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.anchoredRow {\n  display: flex;\n}\n\n.dateGutter {\n  flex-shrink: 0;\n  width: 56px;\n  padding-top: 14px;\n  text-align: center;\n}\n\n.dateMonth {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  color: #a1a1aa;\n}\n\n.dateDay {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 1.1;\n  color: #52525b;\n}\n\n.dateAccent {\n  color: #18181b;\n}\n\n.dateYear {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 10px;\n  color: #a1a1aa;\n}\n\n.spine {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex-shrink: 0;\n  width: 28px;\n}\n\n.spineLead {\n  width: 1.5px;\n  height: 18px;\n  background: #e4e4e7;\n}\n\n.spineTail,\n.spineFull {\n  flex: 1;\n  width: 1.5px;\n  background: #e4e4e7;\n}\n\n.spineFull {\n  min-height: 100%;\n}\n\n.node {\n  flex-shrink: 0;\n  border-radius: 50%;\n}\n\n.nodeVisit {\n  width: 13px;\n  height: 13px;\n  border: 3px solid #ffffff;\n  background: #18181b;\n  box-shadow: 0 0 0 1.5px #18181b;\n}\n\n.nodeUpcoming {\n  width: 13px;\n  height: 13px;\n  border: 3px solid #ffffff;\n  background: #ffffff;\n  box-shadow: 0 0 0 1.5px #a1a1aa;\n}\n\n.nodeGreen {\n  box-shadow: 0 0 0 1.5px #22c55e;\n}\n\n.nodeYellow {\n  box-shadow: 0 0 0 1.5px #eab308;\n}\n\n.nodeRed {\n  box-shadow: 0 0 0 1.5px #ef4444;\n}\n\n.nodeFuture {\n  width: 9px;\n  height: 9px;\n  border: 1.5px dashed #a1a1aa;\n  background: #ffffff;\n}\n\n.nodeDot {\n  width: 7px;\n  height: 7px;\n  background: #d4d4d8;\n}\n\n.rowBody {\n  flex: 1;\n  min-width: 0;\n  padding: 6px 0 18px 12px;\n}\n\n.episodeCard,\n.cluster,\n.upcoming,\n.future {\n  border: 1px solid $hairline;\n  border-radius: 8px;\n  background: #ffffff;\n  overflow: hidden;\n}\n\n.episodeHead,\n.upcomingHead {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 12px 16px 10px;\n}\n\n.episodeTitle {\n  font-size: 15px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.episodeMeta {\n  font-size: 12px;\n  color: #a1a1aa;\n}\n\n.groupBand {\n  padding-left: 16px;\n  padding-right: 16px;\n}\n\n.collapsedCluster {\n  padding: 6px 2px;\n  font-size: 13px;\n  color: #a1a1aa;\n}\n\n.cluster {\n  background: #fafafa;\n}\n\n.clusterOpen {\n  background: #ffffff;\n}\n\n.bandRight {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.bandNow {\n  font-size: 13px;\n  color: #a1a1aa;\n}\n\n.allCompleteText {\n  font-size: 13px;\n  font-weight: 500;\n  color: #15803d;\n}\n\n.upcoming {\n  border-left-width: 4px;\n}\n\n.upcomingGreen {\n  border-color: #bbf7d0;\n  border-left-color: #22c55e;\n}\n\n.upcomingYellow {\n  border-color: #fde68a;\n  border-left-color: #eab308;\n}\n\n.upcomingRed {\n  border-color: #fecaca;\n  border-left-color: #ef4444;\n}\n\n.upcomingNeutral {\n  border-left-color: #a1a1aa;\n}\n\n.upcoming > .episodeMeta {\n  padding: 0 16px 10px;\n}\n\n.upcomingWhen {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 13px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.upcomingReadiness {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 10px 16px 12px;\n  border-top: 1px solid $rule;\n}\n\n.lineButton {\n  @include line-button;\n  margin: 0 8px 10px;\n}\n\n.future {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border-style: dashed;\n  border-color: #d4d4d8;\n}\n\n.futureTitle {\n  font-size: 14px;\n  font-weight: 500;\n  color: #52525b;\n}\n\n.projected {\n  border-style: dashed;\n}\n\n.nowRow {\n  display: flex;\n  align-items: center;\n}\n\n.nowLabel {\n  flex-shrink: 0;\n  width: 56px;\n  text-align: center;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #0369a1;\n}\n\n.nowDot {\n  flex-shrink: 0;\n  width: 9px;\n  height: 9px;\n  margin: 0 9.5px;\n  border-radius: 50%;\n  background: #0ea5e9;\n  box-shadow: 0 0 0 3px #f0f9ff;\n}\n\n.nowLine {\n  flex: 1;\n  height: 1.5px;\n  margin-left: 12px;\n  background: repeating-linear-gradient(90deg, #bae6fd 0 6px, transparent 6px 12px);\n}\n\n.nowDate {\n  padding-left: 10px;\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 12px;\n  color: #a1a1aa;\n}\n\n.switchTrigger svg {\n  width: 12px;\n  height: 12px;\n  color: #a1a1aa;\n}\n\n.episodeHeadRuled {\n  border-bottom: 1px solid $rule;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","$ready: #50ae3d;\n$ready-strong: #48813b;\n$ready-shadow: 0 1px 2px 0 rgba($ready, 0.1), 0 4px 12px -4px rgba($ready, 0.28);\n$ready-shadow-hover: 0 1px 2px 0 rgba($ready, 0.12), 0 6px 16px -4px rgba($ready, 0.34);\n\n$hairline: #e4e4e7;\n$rule: #f4f4f5;\n$label: #71717a;\n$focus: #18181b;\n$tracking-caps: 0.08em;\n\n$visit-kinds: (\n  followUp: (\n    base: #69945f,\n    strong: #48813b,\n  ),\n  consultation: (\n    base: #6687bd,\n    strong: #4972b7,\n  ),\n  infusion: (\n    base: #8e7ab5,\n    strong: #8065b1,\n  ),\n  assessment: (\n    base: #3c9888,\n    strong: #088272,\n  ),\n  carePlan: (\n    base: #3c93ac,\n    strong: #0b7d97,\n  ),\n  other: (\n    base: #7e8791,\n    strong: #6b747e,\n  ),\n);\n\n@mixin focus-ring($offset: 1px) {\n  outline: none;\n\n  &:focus-visible {\n    outline: 2px solid $focus;\n    outline-offset: $offset;\n  }\n}\n\n@mixin line-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: transparent;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  color: #18181b;\n  text-decoration: underline;\n  text-decoration-color: #d4d4d8;\n  text-underline-offset: 3px;\n  cursor: pointer;\n  transition: background-color 0.15s, border-color 0.15s;\n\n  &:hover:not(:disabled) {\n    border-color: #d4d4d8;\n    background: #ffffff;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    text-decoration: none;\n  }\n\n  @include focus-ring;\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    color: #a1a1aa;\n    cursor: default;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `MemberRecord-module__font-s-10___IwqKv`,
	"fontS12": `MemberRecord-module__font-s-12___zs9j6`,
	"fontS13": `MemberRecord-module__font-s-13___yfrzG`,
	"fontS14": `MemberRecord-module__font-s-14___GyuhG`,
	"fontS15": `MemberRecord-module__font-s-15___Z6bKc`,
	"fontS16": `MemberRecord-module__font-s-16___xwOkT`,
	"fontS18": `MemberRecord-module__font-s-18___TmJ3p`,
	"fontS20": `MemberRecord-module__font-s-20___ykdy_`,
	"fontS22": `MemberRecord-module__font-s-22___axURb`,
	"fontS28": `MemberRecord-module__font-s-28___RG62U`,
	"fontW400": `MemberRecord-module__font-w-400___DoAj7`,
	"fontW500": `MemberRecord-module__font-w-500___lR4nh`,
	"fontW600": `MemberRecord-module__font-w-600___Z1btE`,
	"fontW700": `MemberRecord-module__font-w-700___ltZIY`,
	"p5": `MemberRecord-module__p-5___JV9nE`,
	"p12": `MemberRecord-module__p-12___Bj8J_`,
	"p16": `MemberRecord-module__p-16___e4J3m`,
	"p30": `MemberRecord-module__p-30___YJlqb`,
	"pB0": `MemberRecord-module__p-b-0___ttjoh`,
	"pB5": `MemberRecord-module__p-b-5___vHvnu`,
	"pB10": `MemberRecord-module__p-b-10___m0YLw`,
	"pB12": `MemberRecord-module__p-b-12____7HKj`,
	"pB16": `MemberRecord-module__p-b-16___zsBTh`,
	"pB18": `MemberRecord-module__p-b-18___Qw6ML`,
	"pB20": `MemberRecord-module__p-b-20___AEOLV`,
	"pB25": `MemberRecord-module__p-b-25___DZse_`,
	"pB30": `MemberRecord-module__p-b-30___0ZUfI`,
	"pB50": `MemberRecord-module__p-b-50___e41Fz`,
	"pT0": `MemberRecord-module__p-t-0___qxQG_`,
	"pT12": `MemberRecord-module__p-t-12___etBjt`,
	"pT16": `MemberRecord-module__p-t-16___gF9Mz`,
	"pT18": `MemberRecord-module__p-t-18___BUrev`,
	"pT20": `MemberRecord-module__p-t-20___aMfbB`,
	"pT30": `MemberRecord-module__p-t-30___kBEnU`,
	"pT40": `MemberRecord-module__p-t-40___Dg1Ei`,
	"pT50": `MemberRecord-module__p-t-50___dQXxF`,
	"pL20": `MemberRecord-module__p-l-20___mswIQ`,
	"pL30": `MemberRecord-module__p-l-30___GurEm`,
	"pL40": `MemberRecord-module__p-l-40___gvjDh`,
	"pR16": `MemberRecord-module__p-r-16___NqFj_`,
	"pR20": `MemberRecord-module__p-r-20___rmPp8`,
	"pR30": `MemberRecord-module__p-r-30___OcMhu`,
	"pR50": `MemberRecord-module__p-r-50___hq7cr`,
	"pR60": `MemberRecord-module__p-r-60___evv3B`,
	"mB1": `MemberRecord-module__m-b-1___p9zLj`,
	"mB2": `MemberRecord-module__m-b-2___g35np`,
	"mB6": `MemberRecord-module__m-b-6___RrFdS`,
	"mB8": `MemberRecord-module__m-b-8___Ggfcz`,
	"mB10": `MemberRecord-module__m-b-10___la7iB`,
	"mB14": `MemberRecord-module__m-b-14___oKt_8`,
	"mB16": `MemberRecord-module__m-b-16___qvico`,
	"mB20": `MemberRecord-module__m-b-20___CQYDD`,
	"mB22": `MemberRecord-module__m-b-22___xJuiQ`,
	"mB24": `MemberRecord-module__m-b-24___rU17I`,
	"mB30": `MemberRecord-module__m-b-30___bGS4v`,
	"mB32": `MemberRecord-module__m-b-32___HOEUP`,
	"mB40": `MemberRecord-module__m-b-40___CbxAz`,
	"mT2": `MemberRecord-module__m-t-2___gYBGc`,
	"mT3": `MemberRecord-module__m-t-3___qhqBp`,
	"mT4": `MemberRecord-module__m-t-4___ixtcV`,
	"mT5": `MemberRecord-module__m-t-5___JTO04`,
	"mT8": `MemberRecord-module__m-t-8___g9v1V`,
	"mT10": `MemberRecord-module__m-t-10___icFsa`,
	"mT15": `MemberRecord-module__m-t-15___d22vO`,
	"mT16": `MemberRecord-module__m-t-16___PuGkE`,
	"mT20": `MemberRecord-module__m-t-20___gPr_5`,
	"mT22": `MemberRecord-module__m-t-22___R0xu2`,
	"mT30": `MemberRecord-module__m-t-30___Eiitd`,
	"mT32": `MemberRecord-module__m-t-32___ryX2l`,
	"mLAuto": `MemberRecord-module__m-l-auto___c85fR`,
	"mL4": `MemberRecord-module__m-l-4___doPAy`,
	"mL5": `MemberRecord-module__m-l-5___MV1xO`,
	"mL6": `MemberRecord-module__m-l-6___R3azx`,
	"mL8": `MemberRecord-module__m-l-8___xKx6E`,
	"mL10": `MemberRecord-module__m-l-10___B3sLZ`,
	"mL16": `MemberRecord-module__m-l-16___tI8Ft`,
	"mL20": `MemberRecord-module__m-l-20___KWJJO`,
	"mL24": `MemberRecord-module__m-l-24___rcWVu`,
	"mL30": `MemberRecord-module__m-l-30___vGJai`,
	"mL35": `MemberRecord-module__m-l-35___v1SD3`,
	"mL40": `MemberRecord-module__m-l-40___QTWhw`,
	"mR8": `MemberRecord-module__m-r-8___KiBZK`,
	"mR10": `MemberRecord-module__m-r-10___uxJVm`,
	"mR16": `MemberRecord-module__m-r-16___uswxv`,
	"mR20": `MemberRecord-module__m-r-20___M0DvQ`,
	"mR24": `MemberRecord-module__m-r-24___dGdpy`,
	"mR30": `MemberRecord-module__m-r-30___MjLO3`,
	"mR40": `MemberRecord-module__m-r-40___HodzU`,
	"borderR3": `MemberRecord-module__border-r-3___JMyQ2`,
	"borderR4": `MemberRecord-module__border-r-4___STTXa`,
	"borderR6": `MemberRecord-module__border-r-6___QcaCO`,
	"borderR10": `MemberRecord-module__border-r-10___cISOa`,
	"borderR12": `MemberRecord-module__border-r-12___REv0V`,
	"borderR16": `MemberRecord-module__border-r-16___qkmqP`,
	"borderR50": `MemberRecord-module__border-r-50___IVUEh`,
	"primaryBorder": `MemberRecord-module__primary-border___lDlUp`,
	"primaryBorderB": `MemberRecord-module__primary-border-b___zlBwZ`,
	"primaryBorderT": `MemberRecord-module__primary-border-t___mR8SY`,
	"primaryBorderL": `MemberRecord-module__primary-border-l___Ajh0J`,
	"primaryBorderR": `MemberRecord-module__primary-border-r___z3Rla`,
	"secondaryBorder": `MemberRecord-module__secondary-border___Z4zXK`,
	"secondaryBorderB": `MemberRecord-module__secondary-border-b___vYnhk`,
	"secondaryBorderT": `MemberRecord-module__secondary-border-t___g1rQ6`,
	"secondaryBorderL": `MemberRecord-module__secondary-border-l___FEZdc`,
	"secondaryBorderR": `MemberRecord-module__secondary-border-r___tPlvU`,
	"gap0": `MemberRecord-module__gap-0___AwfVP`,
	"gap2": `MemberRecord-module__gap-2___qZkGq`,
	"gap4": `MemberRecord-module__gap-4___I98vK`,
	"gap5": `MemberRecord-module__gap-5___qj1ae`,
	"gap6": `MemberRecord-module__gap-6___pxPiz`,
	"gap8": `MemberRecord-module__gap-8___KxMSc`,
	"gap10": `MemberRecord-module__gap-10___fpYMg`,
	"gap12": `MemberRecord-module__gap-12___BKg_n`,
	"gap14": `MemberRecord-module__gap-14___IGGCO`,
	"gap16": `MemberRecord-module__gap-16___Y5ISY`,
	"gap18": `MemberRecord-module__gap-18___PrDar`,
	"gap20": `MemberRecord-module__gap-20___SLdAc`,
	"gap24": `MemberRecord-module__gap-24___KiSF0`,
	"gap26": `MemberRecord-module__gap-26___H_Pya`,
	"gap30": `MemberRecord-module__gap-30___bhcGg`,
	"gap32": `MemberRecord-module__gap-32___XU0BQ`,
	"gap40": `MemberRecord-module__gap-40___oE04Y`,
	"gap50": `MemberRecord-module__gap-50___YwMHq`,
	"flex1": `MemberRecord-module__flex-1___GvhpR`,
	"flexNone": `MemberRecord-module__flex-none___IKqVw`,
	"flexColumn": `MemberRecord-module__flex-column___ybfeP`,
	"flexRow": `MemberRecord-module__flex-row____RIXi`,
	"verticallyCentered": `MemberRecord-module__vertically-centered___ai8I3`,
	"horizontallyCentered": `MemberRecord-module__horizontally-centered___RH2jB`,
	"horizontallyEnd": `MemberRecord-module__horizontally-end___fA1Ke`,
	"verticallyStart": `MemberRecord-module__vertically-start___pFlIh`,
	"spaceBetween": `MemberRecord-module__space-between___04goC`,
	"flexWrap": `MemberRecord-module__flex-wrap___qmjAN`,
	"height100": `MemberRecord-module__height-100___qkYHH`,
	"width50": `MemberRecord-module__width-50___xw_J9`,
	"width100": `MemberRecord-module__width-100___mIFmG`,
	"cursorPointer": `MemberRecord-module__cursor-pointer___qNoo4`,
	"cursorNotAllowed": `MemberRecord-module__cursor-not-allowed___UAe7H`,
	"absoluteCentered": `MemberRecord-module__absolute-centered___Q6EiG`,
	"absolute": `MemberRecord-module__absolute___UIpKu`,
	"relative": `MemberRecord-module__relative___VI_CY`,
	"fixed": `MemberRecord-module__fixed___ptKh7`,
	"visible": `MemberRecord-module__visible___yCtv1`,
	"invisible": `MemberRecord-module__invisible___Rb6zo`,
	"col90": `MemberRecord-module__col-90___ecrA6`,
	"colAuto": `MemberRecord-module__col-auto___VoNRw`,
	"medicalTabs": `MemberRecord-module__medical-tabs___Y8Lqo`,
	"medicalTableNew": `MemberRecord-module__medical-table-new___YEKEv`,
	"noPagination": `MemberRecord-module__no-pagination___Not4l`,
	"medicalTableEmpty": `MemberRecord-module__medical-table-empty___ZLsOr`,
	"iconBtn": `MemberRecord-module__icon-btn___CBuHo`,
	"searchIcon": `MemberRecord-module__search-icon___HQNgv`,
	"disableSelect": `MemberRecord-module__disable-select___b5i1I`,
	"breakWord": `MemberRecord-module__break-word___hGejV`,
	"popupClearBtn": `MemberRecord-module__popup-clear-btn___Sby4L`,
	"scrollMB20": `MemberRecord-module__scroll-m-b-20___DUSyu`,
	"page": `MemberRecord-module__page___Xw_QX`,
	"pageInner": `MemberRecord-module__pageInner___mAa4D`,
	"flex": `MemberRecord-module__flex___tZ0XY`,
	"crumbs": `MemberRecord-module__crumbs___s8V_d`,
	"crumbButton": `MemberRecord-module__crumbButton___LyJZs`,
	"backButton": `MemberRecord-module__backButton___DuH3H`,
	"crumbSep": `MemberRecord-module__crumbSep___hl27P`,
	"crumbStrong": `MemberRecord-module__crumbStrong___rSBKC`,
	"athena": `MemberRecord-module__athena___oMRDa`,
	"contentBar": `MemberRecord-module__contentBar___fc2Yd`,
	"summary": `MemberRecord-module__summary___QmuS7`,
	"crumbCurrent": `MemberRecord-module__crumbCurrent___U6SXY`,
	"switchTrigger": `MemberRecord-module__switchTrigger___eo37R`,
	"switchMenu": `MemberRecord-module__switchMenu___B3zKH`,
	"switchHeading": `MemberRecord-module__switchHeading___P3mOc`,
	"switchHeadingHint": `MemberRecord-module__switchHeadingHint___baBgn`,
	"switchOption": `MemberRecord-module__switchOption___Xk1Zr`,
	"switchCheck": `MemberRecord-module__switchCheck___DL4Uy`,
	"switchBody": `MemberRecord-module__switchBody___GddhE`,
	"switchOptionCurrent": `MemberRecord-module__switchOptionCurrent___qwJuF`,
	"switchTop": `MemberRecord-module__switchTop___LEHPk`,
	"switchBottom": `MemberRecord-module__switchBottom___XDHtF`,
	"switchName": `MemberRecord-module__switchName___pQVJD`,
	"switchMrn": `MemberRecord-module__switchMrn___OTN8z`,
	"switchDue": `MemberRecord-module__switchDue___zKK8M`,
	"switchDueUrgent": `MemberRecord-module__switchDueUrgent___lwnV6`,
	"switchDueCritical": `MemberRecord-module__switchDueCritical___s221B`,
	"switchTask": `MemberRecord-module__switchTask___GOect`,
	"switchCount": `MemberRecord-module__switchCount___mC5s0`,
	"memberHeader": `MemberRecord-module__memberHeader___tXRW_`,
	"avatar": `MemberRecord-module__avatar___FsucQ`,
	"memberIdentity": `MemberRecord-module__memberIdentity___nokC9`,
	"memberNameLine": `MemberRecord-module__memberNameLine___icHpX`,
	"memberName": `MemberRecord-module__memberName___eXlw_`,
	"memberAge": `MemberRecord-module__memberAge___n9c1y`,
	"memberMrn": `MemberRecord-module__memberMrn___sEC8k`,
	"memberContext": `MemberRecord-module__memberContext___XyJvF`,
	"tabsRow": `MemberRecord-module__tabsRow___RzZQF`,
	"pills": `MemberRecord-module__pills___ZCF7O`,
	"pill": `MemberRecord-module__pill___nXVSG`,
	"pillActive": `MemberRecord-module__pillActive___hVgJd`,
	"pillCount": `MemberRecord-module__pillCount___JyY9H`,
	"toggle": `MemberRecord-module__toggle___lPJOR`,
	"toggleOn": `MemberRecord-module__toggleOn___tLewR`,
	"toggleTrack": `MemberRecord-module__toggleTrack___iDAJC`,
	"toggleThumb": `MemberRecord-module__toggleThumb___avDb3`,
	"errorNote": `MemberRecord-module__errorNote___I_eoo`,
	"emptyNote": `MemberRecord-module__emptyNote___xa3zv`,
	"timelineCard": `MemberRecord-module__timelineCard___rMBlT`,
	"listCard": `MemberRecord-module__listCard___EdVF9`,
	"tasksTab": `MemberRecord-module__tasksTab___d1RMS`,
	"anchoredRow": `MemberRecord-module__anchoredRow___Aqm9W`,
	"dateGutter": `MemberRecord-module__dateGutter___nPm_O`,
	"dateMonth": `MemberRecord-module__dateMonth___k9NMY`,
	"dateDay": `MemberRecord-module__dateDay___UmL83`,
	"dateAccent": `MemberRecord-module__dateAccent___EsV8x`,
	"dateYear": `MemberRecord-module__dateYear___YAr70`,
	"spine": `MemberRecord-module__spine___S2Nry`,
	"spineLead": `MemberRecord-module__spineLead___pDKUH`,
	"spineTail": `MemberRecord-module__spineTail___ldE0W`,
	"spineFull": `MemberRecord-module__spineFull___izuC6`,
	"node": `MemberRecord-module__node___zhxdO`,
	"nodeVisit": `MemberRecord-module__nodeVisit___m2leA`,
	"nodeUpcoming": `MemberRecord-module__nodeUpcoming___eivyN`,
	"nodeGreen": `MemberRecord-module__nodeGreen___N_fSh`,
	"nodeYellow": `MemberRecord-module__nodeYellow___crO9U`,
	"nodeRed": `MemberRecord-module__nodeRed___UrXG_`,
	"nodeFuture": `MemberRecord-module__nodeFuture___fxUlH`,
	"nodeDot": `MemberRecord-module__nodeDot___Ho4l0`,
	"rowBody": `MemberRecord-module__rowBody___gvfA2`,
	"episodeCard": `MemberRecord-module__episodeCard___JNheI`,
	"cluster": `MemberRecord-module__cluster___tbaUF`,
	"upcoming": `MemberRecord-module__upcoming___u49M9`,
	"future": `MemberRecord-module__future___N9Oa1`,
	"episodeHead": `MemberRecord-module__episodeHead___N7mcm`,
	"upcomingHead": `MemberRecord-module__upcomingHead___BT7_M`,
	"episodeTitle": `MemberRecord-module__episodeTitle___Ljv0H`,
	"episodeMeta": `MemberRecord-module__episodeMeta___kUVfJ`,
	"groupBand": `MemberRecord-module__groupBand___SAXJz`,
	"collapsedCluster": `MemberRecord-module__collapsedCluster___iWC08`,
	"clusterOpen": `MemberRecord-module__clusterOpen___EkLvG`,
	"bandRight": `MemberRecord-module__bandRight___poJnN`,
	"bandNow": `MemberRecord-module__bandNow___gXvF3`,
	"allCompleteText": `MemberRecord-module__allCompleteText___rOmLY`,
	"upcomingGreen": `MemberRecord-module__upcomingGreen___kdabb`,
	"upcomingYellow": `MemberRecord-module__upcomingYellow___KL2eE`,
	"upcomingRed": `MemberRecord-module__upcomingRed____x_MU`,
	"upcomingNeutral": `MemberRecord-module__upcomingNeutral___PMQcF`,
	"upcomingWhen": `MemberRecord-module__upcomingWhen___oby23`,
	"upcomingReadiness": `MemberRecord-module__upcomingReadiness___OqIt1`,
	"lineButton": `MemberRecord-module__lineButton___WQvRF`,
	"futureTitle": `MemberRecord-module__futureTitle___hth6D`,
	"projected": `MemberRecord-module__projected___H3wzs`,
	"nowRow": `MemberRecord-module__nowRow___tqi06`,
	"nowLabel": `MemberRecord-module__nowLabel____uSQN`,
	"nowDot": `MemberRecord-module__nowDot___LNCnW`,
	"nowLine": `MemberRecord-module__nowLine___pavZS`,
	"nowDate": `MemberRecord-module__nowDate___yhatn`,
	"episodeHeadRuled": `MemberRecord-module__episodeHeadRuled___tU3ZA`
};
module.exports = ___CSS_LOADER_EXPORT___;
